const DEBUG_STORAGE_KEY = "proview_switcher_debug";

/**
 * Traces every call crossing between this client and the ATX SDK, so the
 * translation between the two surfaces can be checked from the console rather
 * than taken on trust.
 *
 * On outside production, and anywhere once
 * `localStorage.setItem("proview_switcher_debug", "1")` is set — a handoff
 * spanning two clients is worth being able to inspect on a deployed
 * environment too.
 */
const debugEnabled = (): boolean => {
  if (process.env.NODE_ENV !== "production") return true;
  try {
    return localStorage.getItem(DEBUG_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
};

export const trace = (event: string, detail?: unknown): void => {
  if (!debugEnabled()) return;
  if (detail === undefined) {
    console.log(`[switcher] ${event}`);
    return;
  }
  console.log(`[switcher] ${event}`, detail);
};
